import { render, staticRenderFns } from "./wc-icon.vue?vue&type=template&id=7d693d41&scoped=true&"
import script from "./wc-icon.vue?vue&type=script&lang=js&"
export * from "./wc-icon.vue?vue&type=script&lang=js&"
import style0 from "./wc-icon.vue?vue&type=style&index=0&id=7d693d41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d693d41",
  null
  
)

export default component.exports